import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { withToolsSiteMap, processor, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { AssetLibraryIcon } from '@bingads-webui-theme-2018/embeded-svgs';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withRouter } from '@bingads-webui-react/router';
import { withUserConsumer } from '@bingads-webui-react/user-context';
import { createToolbarButton, navigateBySiteMap } from './utilities';

const siteMapId = 'creative-studio-asset-library';

const AssetLibraryButtonEmbeded = createToolbarButton(['global-menu-asset-library-dropdown-toggle']);

export const AssetLibraryButtonInternal = React.memo(({
  i18n,
  scope,
  siteMap,
  history,
  location,
  userContext,
  ...others
}) => {
  const assetLibrarytem = _.findWhere(siteMap, { id: siteMapId });
  if (_.isEmpty(assetLibrarytem)) {
    return null;
  }

  const onClick = () => {
    navigateBySiteMap({
      scope,
      siteMap,
      siteMapId,
      history,
      location,
      userContext,
    });
  };

  const text = i18n.getString(assetLibrarytem.name);
  const svgicon = <AssetLibraryIcon />;

  return (<AssetLibraryButtonEmbeded {...others} onClick={onClick} text={text} svgicon={svgicon} />);
});

AssetLibraryButtonInternal.defaultProps = {
  userContext: {},
};

AssetLibraryButtonInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  userContext: PropTypes.shape({
    CurrentAccount: PropTypes.object,
  }),
};

export const AssetLibraryButton =
  withUserConsumer(withRouter(withScope(withToolsSiteMap(
    AssetLibraryButtonInternal,
    [processor.processPermissions, processor.processPath],
    siteMapId
  ))));
